// @erp/module-cms/fe · the module's typed edge (DEV-GUIDE-002 §6.3 — per-module
// hc client, NOT one giant hc<AppType> everywhere: that anti-pattern crawls the
// editor and defeats tree-shaking, §10). cmsApi is hc<CmsRoutes> based at
// /api/cms — the mount point the gateway gives createCmsRouter — so a call like
// `cmsApi.announcements.$get()` targets `/api/cms/announcements` with the
// portal's cookie-riding defaults (credentials:'include', @erp/api-client).
// Mirrors modules/lib/src/fe/client.ts.
//
// `import type` is load-bearing TWICE over:
//   1. Runtime — a VALUE import of '../api' would drag Hono, the repos, the
//      service layer and every handler into the browser bundle. Type-only, it
//      is erased: zero worker code ships (verbatimModuleSyntax keeps us honest).
//   2. The seam — this is the module's exit criterion: if a cms route leaves the
//      chained expression in api/router.ts (or its response shape drifts),
//      CmsRoutes changes and THIS build fails typecheck. One source of truth for
//      the wire, checked at compile time.
//
// Worker TYPES (not code) do reach this file: CmsRoutes = ReturnType<typeof
// createCmsRouter>, and createCmsRouter is generic over `E extends CmsEnv`,
// whose Bindings name D1Database/R2Bucket (@cloudflare/workers-types globals).
// Resolving CmsRoutes therefore loads api/router.ts's type graph, so the fe
// tsconfig carries `types: ["@cloudflare/workers-types"]` (types only — no
// runtime) + the base's skipLibCheck to mute the DOM/workers-types lib overlap.
import type { CmsRoutes } from "../api/index.js";
import { createApiClient } from "@erp/api-client";

/** The module-scoped hc client. Screens/queries/mutations import THIS, never a portal-wide client. */
export const cmsApi = createApiClient<CmsRoutes>("/api/cms");
export type CmsApi = typeof cmsApi;
